import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import api from "../../api/api";
import { ENDPOINTS } from "../../api/endpoints";

const NotificationDialog = ({ open, onClose, onNotificationAdded, showToast }) => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [forRole, setForRole] = useState('Talent'); // default to Talent

  const [errors, setErrors] = useState({ title: '', message: '' });

  const validate = () => {
    let isValid = true;
    const newErrors = { title: '', message: '' };

    if (!title.trim()) {
      newErrors.title = 'Title is required';
      isValid = false;
    }

    if (!message.trim()) {
      newErrors.message = 'Message is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

const handleSubmit = async () => {
  if (!validate()) return;

  try {
    const payload = {
      id: 0,
      title,
      message,
      forRole,
      activeFlag: true
    };

    await api.post(
      ENDPOINTS.addOrUpdateNotificationMessage(),
      payload
    );

    showToast && showToast('Notification added successfully!', 'success');

    onNotificationAdded && onNotificationAdded();
    onClose();

    setTitle('');
    setMessage('');
    setForRole('Talent');
    setErrors({ title: '', message: '' });

  } catch (error) {
    console.error('Error adding notification:', error);
    showToast && showToast('Failed to add notification.', 'error');
  }
};

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Notification</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            error={Boolean(errors.title)}
            helperText={errors.title}
          />
          <TextField
            label="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            multiline
            rows={4}
            fullWidth
            error={Boolean(errors.message)}
            helperText={errors.message}
          />
          <FormControl fullWidth>
            <InputLabel id="role-select-label">For Role</InputLabel>
            <Select
              labelId="role-select-label"
              value={forRole}
              label="For Role"
              onChange={(e) => setForRole(e.target.value)}
            >
              <MenuItem value="Talent">Talent</MenuItem>
              <MenuItem value="Director">Director</MenuItem>
              <MenuItem value="Both">Both</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDialog;
